/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "a595539bde12d89eee99966596305f715f82c7d7";
